export function camelToSnake(camelcaseString: string) {
  return camelcaseString.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
}
